import { Box } from "@mui/material";
import KpiCard from "./KpiCard";

/**
 * Escolhe a quantidade de colunas que distribui `count` cards SEM linha
 * quebrada/órfã. Regra:
 *  - cabe tudo numa linha (count <= maxCols) → count colunas;
 *  - senão, prefere um divisor exato (linhas perfeitamente cheias):
 *      6 → 3 (3x2, nunca 4x2) · 9 → 3 (3x3, nunca 4x4x1) · 8 → 4 (4x2);
 *  - sem divisor exato, usa o maior nº de colunas que não deixe 1 card
 *    sozinho na última linha (ex.: 7 → 4 = 4+3; 5 → 3 = 3+2).
 */
export function getBalancedColumns(count, maxCols = 4) {
  const n = Number(count) || 0;
  if (n <= 1) return 1;
  if (n <= maxCols) return n;

  for (let c = maxCols; c >= 2; c -= 1) {
    if (n % c === 0) return c; // divisor exato → linhas cheias
  }
  for (let c = maxCols; c >= 2; c -= 1) {
    if (n % c !== 1) return c; // evita 1 card órfão na última linha
  }
  return maxCols;
}

export default function KpiGrid({ metrics }) {
  const items = Array.isArray(metrics) ? metrics : [];
  if (items.length === 0) return null;

  // md+ ocupa toda a largura com colunas balanceadas; xs/sm responsivos.
  const desktopCols = getBalancedColumns(items.length, 4);
  const tabletCols = Math.min(2, desktopCols);

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "repeat(1, minmax(0, 1fr))",
          sm: `repeat(${tabletCols}, minmax(0, 1fr))`,
          md: `repeat(${desktopCols}, minmax(0, 1fr))`,
        },
        gap: 2,
        my: 3,
        width: "100%",
      }}
    >
      {items.map((metric) => (
        <KpiCard key={metric.label} {...metric} />
      ))}
    </Box>
  );
}
